module.exports = __webpack_public_path__ + "20250721160708/img/homework.3686059d.png";